export default __webpack_public_path__ + "static/media/ph1.0579a074.webp";